/**
 * Console 拦截器
 * 在生产环境禁用所有 console 输出
 */
export const initConsoleInterceptor = () => {
  if (process.env.NODE_ENV === 'production') {
    const noop = () => {};
    console.log = noop;
    console.debug = noop;
    console.info = noop;
    console.warn = noop;
    console.error = noop;
  }
};

